export default __webpack_public_path__ + "loader.2341f6e2.svg";